/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in local storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    if (typeof productId !== 'string' || !/^[1-9]\d{0,19}$/.test(productId)) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (_) {
      // Browsing must still work when optional storage is blocked or full.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch (_) {
      // Optional history is unavailable in this browser context.
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const stored = localStorage.getItem(this.#STORAGE_KEY);
      if (!stored || stored.length > 4096) return [];
      const products = JSON.parse(stored);
      if (!Array.isArray(products)) return [];
      return [...new Set(products.filter((id) => typeof id === 'string' && /^[1-9]\d{0,19}$/.test(id)))].slice(
        0,
        this.#MAX_PRODUCTS
      );
    } catch (_) {
      return [];
    }
  }
}
